import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './switch.scss';

@customElement('cookie-setting-switch')
export class Switch extends LitElement {
  static override styles = unsafeCSS(styles);

  @property({
    converter: (value: string | null) => 'true' === value,
  })
  value = false;
  @property() name = '';
  @property({
    converter: (value: string | null) => 'true' === value,
  })
  disabled = false;

  private handleCheck(ev: Event) {
    const { checked } = ev.target as HTMLInputElement;
    this.dispatchEvent(
      new CustomEvent('checkedChange', {
        detail: checked,
      }),
    );
  }

  override render() {
    return html`
      <div
        class=${classMap({
          'tiktok-cookie-setting-switch': true,
          checked: this.value,
          disabled: this.disabled,
        })}
        role="switch"
        aria-checked=${this.value}
      >
        <div class="tiktok-cookie-setting-switch-knob"></div>
        <input
          @change=${this.handleCheck}
          ?checked=${this.value}
          type="checkbox"
          role="switch"
          class="tiktok-cookie-setting-switch-native-control"
          name=${this.name}
        />
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cookie-setting-switch': Switch;
  }
}
